import { motion } from 'framer-motion'

import { VertSpacerLg, VertSpacerMd } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { GRID_CARD_VARIANTS } from '@apps-common/config/motion-variants'
import { formatCurrency } from '@apps-common/helpers/currency'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IUnitPlanModel } from '@apps-common/types/management/unit-plan'

import { ButtonRoundedWithIcon } from '@apps-common/components/elements'
import { UnitPlanModal } from './UnitPlanModal'

interface IProps {
  plan: IUnitPlanModel
  onChangeCallback: () => void
}
export const UnitPlanListCard = ({ plan, onChangeCallback }: IProps) => {
  const { unitPlanId, unitPlanName, defaultItem, price, status } = plan

  return (
    <motion.div variants={GRID_CARD_VARIANTS} className='w-full p-6 rounded-[35px] bg-surface text-text border border-border'>
      <div className='flex items-center justify-between w-full'>
        <div className='jost-light text-[0.9em]'>{unitPlanName}</div>
      </div>
      <div className='flex flex-col gap-[5px] text-[0.9em]'>
        <VertSpacerMd />
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
          <p className='jost-light text-ellipsis overflow-hidden bg-surface-2 leading-[1em] p-1 rounded'>Price</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{formatCurrency(price)}</p>
        </div>
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
          <p className='jost-light text-ellipsis overflow-hidden bg-surface-2 leading-[1em] p-1 rounded'>Default item</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{defaultItem ? 'Yes' : 'No'}</p>
        </div>
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
          <p className='jost-light text-ellipsis overflow-hidden bg-surface-2 leading-[1em] p-1 rounded'>Status</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{status}</p>
        </div>
      </div>
      <VertSpacerLg />
      <ModalButton
        classes='w-full flex justify-end'
        component={UnitPlanModal}
        disabled={false}
        componentProps={{
          unitPlanId
        }}
        enterAnimation={modalSlideUpEnterAnimation}
        leaveAnimation={modalSlideUpLeaveAnimation}
      >
        <ButtonRoundedWithIcon
          type='div'
          text='Details'
          icon={<commonIcons.arrowAngled />}
          className='action-brand !w-auto !grow-0'
          iconContainerClassName='bg-brand text-on-brand'
        />
      </ModalButton>
    </motion.div>
  )
}
